import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { useSEO } from '@/components/feature/useSEO';

const FORM_URL = 'https://readdy.ai/api/form/d9u0vun8l97n3eas3fdg';

export default function Home() {
  useSEO({
    title: '一起草 - 多人协同文稿创作平台',
    description: '一起草是专为团队打造的多人协同文稿创作工具，支持实时共同编辑、版本管理与智能审阅。无论是合同、方案还是创意文案，一起草帮你告别反复传文件的烦恼。',
    keywords: '一起草,一起草稿协作,多人在线协同编辑,团队文档共创,实时共享文档,在线写作工具,协同办公平台',
    canonicalUrl: 'https://utshealth.cn',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      'name': '一起草',
      'url': 'https://utshealth.cn',
      'description': '一起草是专为团队打造的多人协同文稿创作工具，支持实时共同编辑、版本管理与智能审阅。',
      'potentialAction': {
        '@type': 'SearchAction',
        'target': 'https://utshealth.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <StatsSection />
        <CategorySection />
        <TestimonialSection />
        <CTASection formUrl={FORM_URL} />
      </main>
      <Footer />
    </>
  );
}